import { Icon } from '@common/components/Icon';
import React, { useEffect } from 'react';
import { Keyboard, Navigation, Pagination, Parallax } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

type ImageGalleryWebProps = {
  images: string[];
  title: string;
  header: boolean;
  onSlideChange?: (slide: number) => void;
  initial?: number;
  showAsset: () => void;
  mode: 'desktop' | 'mobile';
};

export const ImageGalleryWeb: React.FC<ImageGalleryWebProps> = ({
  images,
  initial = 0,
  onSlideChange,
  showAsset,
  mode,
}) => {
  const handleKeyboardEvents = (e: KeyboardEvent) => {
    if (e.key === 'Escape') showAsset();
  };

  useEffect(() => {
    document.body.addEventListener('keydown', handleKeyboardEvents);
    return () => document.body.removeEventListener('keydown', handleKeyboardEvents);
  });

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
      }}>
      <div
        style={{
          width: '95%',
        }}>
        {/* Header */}
        <div
          style={{
            cursor: 'pointer',
            padding: mode === 'desktop' ? 50 : 20,
            position: 'absolute',
            right: 0,
            top: 0,
          }}
          onClick={showAsset}>
          <div
            style={{
              alignItems: 'center',
              background: '#f1f1f1',
              borderRadius: 100,
              display: 'inline-flex',
              height: 34,
              justifyContent: 'center',
              pointerEvents: 'none',
              width: 34,
            }}>
            <Icon icon="times" color="black" boxSize={'20px'} />
          </div>
        </div>
        {/* Content */}
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            padding: mode === 'desktop' ? 50 : 0,
          }}>
          <Swiper
            modules={[Navigation, Pagination, Keyboard, Parallax]}
            slidesPerView={1}
            onSlideChange={(swiper) => {
              if (onSlideChange) onSlideChange(swiper.activeIndex);
            }}
            observer={true}
            observeParents={true}
            parallax={true}
            navigation={mode === 'desktop'}
            keyboard
            pagination={{ clickable: true }}
            initialSlide={initial}>
            {images.map((image, i) => {
              return (
                <SwiperSlide key={`slide-${i}`} style={{ alignSelf: 'center', display: 'flex' }}>
                  <img style={{ margin: '10%', objectFit: 'contain', width: '80%' }} src={image}></img>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};
